import React from 'react';
import { useLoadScript } from '@react-google-maps/api';
import { FullPageMap, MARKER_COLORS } from './FullPageMap';

const libraries = ['places', 'visualization', 'marker'];

const GoogleMapsWrapper = () => {
  const googleApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const heatmapData = [
    { lat: -1.2564, lng: 36.7999, weight: 8 },
    { lat: -1.2684, lng: 36.8119, weight: 1.5 },
    { lat: -1.2921, lng: 36.8219, weight: 4 },
    { lat: -1.2384, lng: 36.8853, weight: 6 },
    { lat: -1.2754677615493655, lng: 36.78692773678684, weight: 6 },
  ];

  // Example marker data
  const markerData = [
    {
      lat: -1.262797935017635,
      lng: 36.81496056160308,
      color: MARKER_COLORS.PURPLE
    },
    {
      lat: -1.2523033243252784,
      lng: 36.76376172140032,
      color: MARKER_COLORS.BLUE
    },
    {
      lat: -1.2367609354317792,
      lng: 36.769331904033415,
      color: MARKER_COLORS.GREEN
    },
    {
      lat: -1.2787305057312601,
      lng: 36.77519156793058,
      color: MARKER_COLORS.YELLOW
    },
    {
      lat: -1.2330885661263382,
      lng: 36.82040718337582,
      color: MARKER_COLORS.GREEN
    },
    {
      lat: -1.2899222766584428,
      lng: 36.72166746959164,
      color: MARKER_COLORS.BLUE
    }
  ];

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: googleApiKey,
    libraries,
    id: 'google-map-script', // Avoid multiple injections
  });

  if (loadError) return <div>Error loading Google Maps</div>;
  if (!isLoaded) return <div>Loading Google Maps...</div>;

  return (
    <FullPageMap
      heatmapData={heatmapData}
      markerData={markerData}
    />
  );
};

export default GoogleMapsWrapper;
